import React from 'react';
import { InputElement as InputType } from '../../types/element.types';

interface InputElementProps {
  element: InputType;
}

/**
 * Input Element Renderer
 */
const InputElement: React.FC<InputElementProps> = ({ element }) => {
  const { label, placeholder, inputType, required, name } = element.settings || {};

  return (
    <div className="input-element-wrapper">
      {label && (
        <label className="block text-sm font-medium mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        type={inputType || 'text'}
        placeholder={placeholder}
        required={required}
        name={name}
        className="input-element"
        style={element.styles as React.CSSProperties}
      />
    </div>
  );
};

export default InputElement;

